import { render, staticRenderFns } from "./EmailSending.vue?vue&type=template&id=4f49ea8a"
import script from "./EmailSending.vue?vue&type=script&lang=js"
export * from "./EmailSending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports